<template>
  <div class="mall-booking">
    <div class="page">
      <div class="mall-booking__header">
        <img class="mall-booking__logo" src="@/assets/mall/img_soldoc_mall_logo.svg" alt="솔닥 컨시어지" />
      </div>

      <div class="mall-booking__back" @click="goBack">
        <img src="@/assets/mall/icn_chevron_left_gray.svg" alt="" />
        <span>홈으로</span>
      </div>

      <div class="mall-booking__title">
        원하는 시간, 편안한 장소에서<br />
        <span class="mall-booking__title-accent">비대면 진료</span>를 받아보세요
      </div>

      <div class="mall-booking__steps">
        <MallBookingStep
          v-for="step in steps"
          :key="step.title"
          :icon="step.icon"
          :title="step.title"
          :descriptionLines="step.descriptionLines"
        />
      </div>

      <div class="mall-booking__notice">
        병원은 솔닥 제휴 병원입니다. 원활한 진료를 위해<br />
        낯선 번호로 전화가 오더라도 꼭 받아주세요!
      </div>

      <div class="mall-booking__button" @click="openChannelTalk">
        <img src="@/assets/mall/icn_booking_headset.svg" alt="" />
        <span>상담원과 채팅으로 예약하기</span>
      </div>
    </div>
  </div>
</template>

<script>
import mall from '@/utilities/mall.js'
import MallBookingStep from '@/components/new/molecules/MallBookingStep.vue'

var CHANNEL_PLUGIN_KEY = '90e69520-1088-43c6-a1cc-3019437a9be8'

export default {
  name: 'MallBooking',
  components: {
    MallBookingStep,
  },
  data() {
    return {
      profileId: Number(this.$route.query.profileId) || null,
      steps: [
        {
          icon: require('@/assets/mall/icn_booking_chat.svg'),
          title: 'Step 1. 상담원 채팅',
          descriptionLines: ['하단 버튼을 누르면 솔닥 컨시어지와', '연결되어 예약을 도와드려요.'],
        },
        {
          icon: require('@/assets/mall/icn_booking_hospital.svg'),
          title: 'Step 2. 제휴 병원 매칭',
          descriptionLines: ['상담원 상담 후 솔닥 컨시어지', '제휴 병원과의 예약이 완료되어요.'],
        },
        {
          icon: require('@/assets/mall/icn_booking_call.svg'),
          title: 'Step 3. 전화 진료 진행',
          descriptionLines: ['예약한 시간에 의사 선생님이', '전화를 드려요. 꼭 받아주세요!'],
        },
      ],
    }
  },
  mounted() {
    // 이 화면에서는 채널톡 상담 버튼(채팅 상담)을 노출
    // TODO: 프로필 정보(이름, 연락처 등)를 함께 전달할지 확인
    ChannelIO('boot', {
      'pluginKey': CHANNEL_PLUGIN_KEY,
    })
  },
  beforeDestroy() {
    ChannelIO('shutdown')
  },
  methods: {
    goBack() {
      mall.goBack(this.$router, this.$route, { path: '/mall/shop', query: { profileId: this.profileId } })
    },
    openChannelTalk() {
      ChannelIO('showMessenger')
    },
  },
}
</script>

<style scoped>
  /* 진료예약 화면 캡처(Figma 197:10243) 기준 크기 */
  .mall-booking {
    display: flex;
    width: 100%;
    min-height: 100vh;
    justify-content: center;
    align-items: flex-start;
  }
  .page {
    width: 100%;
    min-height: 100vh;
    padding: 0 20px 32px 20px;
    background: #FFF;
    box-sizing: border-box;
    font-family: Pretendard;
  }
  .mall-booking__header {
    display: flex;
    height: 56px;
    align-items: center;
  }
  .mall-booking__logo {
    display: block;
    width: auto;
    height: 23px;
  }
  .mall-booking__back {
    display: inline-flex;
    height: 36px;
    align-items: center;
    gap: 8px;
    color: #888888;
    font-size: var(--font-size-sm);
    font-weight: 400;
    cursor: pointer;
  }
  .mall-booking__back img {
    display: block;
  }
  .mall-booking__title {
    margin-top: 23px;
    color: #222222;
    font-size: var(--font-size-2xl);
    font-weight: var(--font-weight-bold);
    line-height: 32px;
    text-align: center;
  }
  .mall-booking__title-accent {
    color: #054B9B;
  }
  .mall-booking__steps {
    margin-top: 35px;
    border-bottom: 1px solid #ECECEC;
  }
  .mall-booking__notice {
    margin-top: 27px;
    padding: 14px 0;
    border-radius: 10px;
    background: #F9FAFB;
    color: #555555;
    font-size: var(--font-size-sm);
    font-weight: 400;
    line-height: 18.5px;
    text-align: center;
  }
  .mall-booking__button {
    display: flex;
    height: 51px;
    margin-top: 20px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 26px;
    background: #1F4A96;
    color: #FFF;
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-bold);
    cursor: pointer;
  }
  .mall-booking__button img {
    display: block;
  }
  @media (min-width: 600px) {
    .page {
      width: 600px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/new/MallBooking.vue